<template>
    <figure
        class="image-container"
        :class="{
            'text': module.view == 'content-wide',
            'wide': !module.view || module.view == 'default',
            'full': module.view == 'no-padding'
        }"
    >
        <div class="image-wrapper">
            <WebpImage
                @click.native="$parent.openGallery"
                :image="{
                    width: module.image.width,
                    height: module.image.height,
                    src: module.src
                }"
            />
        </div>

        <figcaption
            class="f-small color-gray-0 mt-2 caption-material"
            v-if="module.showCaption && module.caption"
            v-html="module.caption"
        />
    </figure>
</template>


<script>
    import WebpImage  from '~/components/case/Image.vue';

    export default {
        props: ['module'],

        components: {
            WebpImage
        }
    }
</script>


<style lang="scss" scoped>
    .image-container {
        margin-top:    0;
        margin-bottom: 0;

        > figcaption {
            margin: 16px auto;
        }

        &.text,
        &.wide {
            margin-right: auto;
            margin-left:  auto;
        }

        > figcaption,
        &.text {
            max-width: 680px;
        }

        &.full {
            margin-right:  -16px;
            margin-left:   -16px;
            padding-right: 16px;
            padding-left:  16px;

            > .image-wrapper {
                margin-right: -16px;
                margin-left:  -16px;
            }
        }
    }

    .image-wrapper {
        position: relative;
        overflow: hidden;
    }
</style>
